/**
 * A module of methods that you want to include in all stores.
 * This module is consumed by `createStore`.
 */
module.exports = {
};



/*****************
 ** WEBPACK FOOTER
 ** /Users/dlopuch/developer/projects-venture-dealr/~/reflux/src/StoreMethods.js
 ** module id = 109
 ** module chunks = 0
 **/